import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 5,
	viewBox: "0 0 9 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5 4.5L4.5 0.5L0.5 4.5",
		stroke: "#03142E",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowUp;
